import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueAwesomeSwiper from 'vue-awesome-swiper'    /*用swiper */
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper,/* { default global options } */)

import tip from "../static/plugin/tip"
Vue.use(tip)

// import VConsole from "vconsole"  /**手机端调试用   上线删除 */
// var vConsole = new VConsole();


//引入样式表
import '../static/css/reset.css'  //重置样式
import '../static/css/common.css'  //公用样式
import '../static/css/stylus/base.styl'

import '../static/js/slider.js'

const noLoadName = ['login','menuList','breakMissing',"breakStockout","breakAisleFault",
                      "changePassword","not404","not505","service"] /**不需要载入动画的页面名 */

router.beforeEach((to,from,next)=>{
  if(to.meta.title){
    document.title = to.meta.title /**改变页面名字 */
  }

  if(noLoadName.indexOf(to.name) == -1){ /**进入页面是  先出现加载动画 */
    store.dispatch('load/showGo',true)
  }

  store.dispatch("options/alertShowGo",{status:false}) /**关闭所有下拉列表弹窗 */

  store.dispatch("options/clearAllGo").then(()=> next())  /**清空已选择的内容 */

})

Vue.filter('numberSymbol',(value,decimal,ismoney,ceil)=>{  /**将传进去的数字转为带逗号的 */ /**第一个false没小数 第二个强制开启小数 啥都不传 有小数就返回小数 没有就返回整数 */
  decimal = decimal === false ? false : true  /**传false不要小数  默认为true */
  ceil = ceil === true /**是否需要整数部分四舍五入  传true就是整数部分四舍五入*/
  ismoney = ismoney === true  /**是钱就默认保留两位小数 */
  let val = Number(value)  /**将值转为数字 */
  let parseBefore = !ceil ? parseInt(val).toString() : val.toFixed(0).toString()  /**取整 */
  let parse = parseBefore.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')  /**每3位加逗号 */
  let floatBefore = val.toFixed(2) /**取消数 */
  let floatArr = floatBefore.split(".")  /**讲数转为整数和小数的数组 */
  let float = floatArr[1]  /**取得小数部分 */
  float = float === '00' ? "" : '.' + float
  ismoney ? float = '.' + floatArr[1] : float
  return decimal ? parse + float : (ismoney ? parse + float : parse)
})

Vue.directive('iosbugscroll', {
  inserted: function(el, binding, vnode) {
    var ua = navigator.userAgent.toLowerCase();
    if(/micromessenger/.test(ua)) {
      if(/iphone|ipad|ipod/.test(ua)) {
        // input、textarea被组件包装的场景
        const childInput = el.getElementsByTagName('input');
        const childTextarea = el.getElementsByTagName('textarea');
        for (let i = 0; i < childInput.length; i++) { 
          childInput[i].onblur = function temporaryRepair() {
            setTimeout(function() {
              checkWxScroll();
            }, 200);
          };
        }
       
        for (let i = 0; i < childTextarea.length; i++) {
          childSelect[i].onblur = function temporaryRepair() {
            setTimeout(function() {
              checkWxScroll();
            }, 200);
          };
        }
        // input、textarea中的场景
        el.onblur = function temporaryRepair() {
          setTimeout(function() {
            checkWxScroll();
          }, 200);
        };
      }
    }
  }
});

function checkWxScroll() {
  var currentPosition, timer;
  var speed = 1; 
  timer = setInterval(function() {
    currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
    currentPosition-=speed;
    window.scrollTo(0,currentPosition);
    currentPosition+=speed; 
    window.scrollTo(0,currentPosition);
    clearInterval(timer);
  }, 1);
}


import homeIcon from "./components/common/homeIcon"

Vue.component("homeIcon",homeIcon)


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js